import * as Yup from 'yup';
import { StepOriginatorForm } from './step-originator-types';
import { PersonType } from '../../../models/uform';
import { addressFieldSchema } from '../../../components/form/address-field/address-field-schema';
import { FileRef } from '@eas/common-web';
import { validateIco } from '../../subject/fields/subjects-utils';
import { dataBoxValidationSchema } from '../../../utils/common-validation-schemas';

export const stepOriginatorSchema = () =>
  Yup.object<StepOriginatorForm>().shape({
    actor: Yup.object({
      firstName: Yup.string().optional(),
      lastName: Yup.string().optional(),
      birthDate: Yup.string().nullable().required('Povinné pole'),
      address: addressFieldSchema().nullable(),
      idNumber: Yup.string().optional().nullable(),
      preferredResponseChannel: Yup.mixed<'ISDS' | 'MAIL'>().optional(),
      email: Yup.string().optional().nullable(),
      phone: Yup.string().optional().nullable(),
      proxy: Yup.boolean().nullable(),
      executiveDeclaration: Yup.boolean().optional(),
      databox: dataBoxValidationSchema.optional(),
      powerOfAttorney: Yup.mixed<FileRef>()
        .nullable()
        .when(['proxy', 'executiveDeclaration'], {
          is: (proxy, executiveDeclaration) =>
            proxy === true && executiveDeclaration !== true,
          then: Yup.mixed<FileRef>().required('Povinné pole'),
          otherwise: Yup.mixed<FileRef>().nullable(),
        }),
    }).optional(),
    representedPerson: Yup.object({
      type: Yup.mixed<PersonType>().optional(),
      firstName: Yup.mixed().when('type', {
        is: PersonType.NATURAL_PERSON,
        then: Yup.string().nullable().required('Povinné pole'),
      }),
      lastName: Yup.mixed().when('type', {
        is: PersonType.NATURAL_PERSON,
        then: Yup.string().nullable().required('Povinné pole'),
      }),
      birthDate: Yup.mixed().when('type', {
        is: PersonType.NATURAL_PERSON,
        then: Yup.string().nullable().required('Povinné pole'),
      }),
      idNumber: Yup.mixed().when('type', {
        is: PersonType.NATURAL_PERSON,
        then: Yup.string().nullable().required('Povinné pole'),
      }),
      ico: Yup.mixed().when('type', {
        is: PersonType.BUSINESS_PERSON,
        then: validateIco,
      }),
      email: Yup.string().optional().nullable(),
      phone: Yup.string().optional().nullable(),
      companyName: Yup.mixed().when('type', {
        is: PersonType.BUSINESS_PERSON,
        then: Yup.string().nullable().required('Povinné pole'),
      }),
      databox: Yup.mixed().when('type', {
        is: (val) => val !== PersonType.FOREIGN_PERSON,
        then: dataBoxValidationSchema.optional(),
      }),
      address: addressFieldSchema({
        country: {
          required: false,
        },
        municipality: {
          required: false,
        },
      })
        .optional()
        .nullable(),
      differentContactAddress: Yup.boolean().nullable(),
      contactAddress: addressFieldSchema({
        country: {
          required: false,
        },
        municipality: {
          required: false,
        },
      })
        .optional()
        .nullable(),
    })
      .nullable()
      .test('Typ', '', function () {
        const { createError, parent } = this;

        if (parent?.actor?.proxy && !parent?.representedPerson?.type) {
          return createError({
            path: 'representedPerson.type',
            message: 'Povinné pole',
          });
        }
        return true;
      }),
  });
